export const depositPaymentRouter = [
  {
    path: "/projectPayment/depositPayment/list",
    name: "deposit-payment-list",
    meta: { title: "保证金支付" },
    component: () =>
      import(/* webpackChunkName: "depositPayment" */ "@/views/project-payment/depositPayment/list/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/depositPayment/create",
    name: "deposit-payment-create",
    meta: { title: "新增保证金支付",comName:"projectPaymentDepositPaymentFormCreate" },
    component: () =>
      import(/* webpackChunkName: "depositPayment" */ "@/views/project-payment/depositPayment/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/depositPayment/edit/:id",
    name: "deposit-payment-edit",
    meta: { title: "编辑保证金支付",comName:"projectPaymentDepositPaymentFormCreate" },
    component: () =>
      import(/* webpackChunkName: "depositPayment" */ "@/views/project-payment/depositPayment/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/projectPayment/depositPayment/detail/:id",
    name: "deposit-payment-detail",
    meta: { title: "保证金支付详情" },
    component: () =>
      import(
        /* webpackChunkName: "depositPayment" */ "@/views/project-payment/depositPayment/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/projectPayment/depositPayment/flowPrint/:id",
    name: "deposit-payment-flowPrint",
    meta: { title: "打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "depositPayment" */ "@/views/project-payment/depositPayment/flow-print/index.vue"
      ),
  },
];